import { Component, OnInit } from '@angular/core';
import { ComplexAttachements } from '../../models/complex-attachements';
import { DomSanitizer } from '@angular/platform-browser';
import { ComplexAttachementsService } from '../../services/complex-attachements-service';
import { downloadFileUtil } from '../../../../shared/utils/file-downloader';
import { NbDialogRef } from '@nebular/theme';
import { Router } from '@angular/router';

@Component({
  selector: 'complex-attachements-details',
  templateUrl: './complex-attachements-details.component.html',
  styleUrls: ['./complex-attachements-details.component.scss'],
})
export class ComplexAttachementsDetailsComponent implements OnInit {
  model = {} as ComplexAttachements;
  constructor(
    private sanitizer: DomSanitizer,
    private service: ComplexAttachementsService,
    private diag: NbDialogRef<ComplexAttachementsDetailsComponent>,
    private route : Router
  ) {}

  getLabelData(text) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

  ngOnInit() {
      this.route.events.subscribe(()=>{
      this.diag.close('false');
     });
  }
  downloadFile(fileName) {
    this.service.downloadFile(fileName).subscribe((blob) => {
      downloadFileUtil(blob, fileName);
    });
  }

  close() {
    this.diag.close();
  }
}
